import { useAuthContext } from "contexts/AuthContext"
import { useGlobalAlert } from "contexts/GlobalAlertContext"
import { useState } from "react"
import { studentRequest } from "services/requests"

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)
  const { showAlert } = useGlobalAlert()
  const { selectedGroupData } = useAuthContext()

  const getLibrary = async ({
    moduleTypeId = -1,
    onlyFavorites = false,
    search = "",
    controller,
    fullResponse = false,
    contentLanguageId,
  }) => {
    setIsFetching(true)
    const isCustomLanguage = selectedGroupData?.customLearningLanguageId > 0
    const laguanageId =
      contentLanguageId !== undefined
        ? contentLanguageId
        : isCustomLanguage
        ? selectedGroupData?.customLearningLanguageId
        : selectedGroupData?.learningLanguageId
    const response = await studentRequest.sendRequest({
      endpoint: `library?ModuleTypeId=${moduleTypeId}&OnlyFavorites=${onlyFavorites}&Search=${search}${
        laguanageId ? `&contentLanguageId=${laguanageId}` : ""
      }`,
      body: null,
      method: "get",
      controller,
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success && !response.aborted) {
      showAlert(response.message, teacherImage)
    }
    setIsFetching(false)
    if (fullResponse) {
      return response
    }
    return response?.data || []
  }

  const setFavorite = async ({ moduleId, isFavorite }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `library?ModuleId=${moduleId}&IsFavorite=${isFavorite}`,
      body: { moduleId, isFavorite },
      method: "post",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data
  }

  const getActivityContent = async ({ moduleId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `activityContent/module/base/${moduleId}`,
      body: null,
      method: "get",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success)
      showAlert(response.message || "Something went wrong", teacherImage)
    setIsFetching(false)
    return response.data
  }

  const getExercises = async ({ moduleId, activityId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `activityContent/exercise/base/${moduleId}/${activityId}`,
      body: null,
      method: "get",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success)
      showAlert(response.message || "Something went wrong", teacherImage)
    setIsFetching(false)
    return response.data
  }

  const getAuthWebToken = async ({ page, reference }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `auth/webToken?page=${page}&reference=${reference}`,
      body: {},
      method: "post",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data
  }

  return {
    getLibrary,
    setFavorite,
    getActivityContent,
    getExercises,
    isFetching,
    getAuthWebToken,
  }
}

export default useApi
